export default __webpack_public_path__ + "static/media/citylitics-logo-primary-inverse.1d529f8a.png";